import { Component, Input } from '@angular/core';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomNativeDateAdapter } from '../../../../../../../../config/date-adapter/custom-native-date-adapter.service';
import { CUSTOM_NATIVE_DATE_FORMATS } from '../../../../../../../../config/date-adapter/custom-date-formats';

@Component({
  selector: 'app-date-filter',
  standalone: true,
  templateUrl: './date-filter.component.html',
  imports: [
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatDatepicker,
    MatLabel,
    MatSuffix,
    MatError
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomNativeDateAdapter },
    {
      provide: MAT_DATE_FORMATS,
      useValue: CUSTOM_NATIVE_DATE_FORMATS
    }
  ],
  styleUrl: './date-filter.component.scss'
})
export class DateFilterComponent {
  @Input() paramsGroup!: FormGroup;
}
